module.exports = __webpack_public_path__ + "img/bg_workflow.ae195474.jpg";